import { render, staticRenderFns } from "./PcFooter.vue?vue&type=template&id=6fb3562e&scoped=true&"
import script from "./PcFooter.vue?vue&type=script&lang=js&"
export * from "./PcFooter.vue?vue&type=script&lang=js&"
import style0 from "./PcFooter.vue?vue&type=style&index=0&id=6fb3562e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb3562e",
  null
  
)

export default component.exports